import React from "react";
import classes from "./Header.module.scss";
import Tooltip from "@material-ui/core/Tooltip";
import { RiSmartphoneLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";

const SmartPhone = () => {
  const { t } = useTranslation();
  const LINK = "https://www.vkitaki.ir/fa/get-app";
  function Download() {
    window.open(LINK);
  }
  return (
    <Tooltip title={t("header.download_app")} arrow placement="bottom">
      <div
        className={classes.showHeader}
        style={{ position: "relative", marginRight: "10px" }}
        onClick={() => Download()}
      >
        <div className={classes.headerButton}>
          <RiSmartphoneLine
            className={classes.icons}
            style={{ margin: "1px", fontSize: "21px" }}
            fontSize={"small"}
          />
        </div>
      </div>
    </Tooltip>
  );
};

export default SmartPhone;
